const categories = [
  {
    id: "languages",
    title: "Languages",
    skills: ["JavaScript", "TypeScript", "C#", "Python", "PHP", "SQL"],
  },
  {
    id: "backend",
    title: "Backend & Architecture",
    skills: [
      "Node.js (Express, NestJS)",
      ".NET",
      "Django",
      "Laravel",
      "REST APIs",
      "gRPC / Protobuf",
      "WebSockets (Socket.IO)",
      "Webhooks",
    ],
  },
  {
    id: "data",
    title: "Datastores & Async",
    skills: [
      "PostgreSQL",
      "MongoDB",
      "MySQL",
      "Redis",
      "Prisma / Sequelize / Drizzle",
      "BullMQ",
      "Transactional Outbox",
      "Idempotent Job Design",
    ],
  },
  {
    id: "mobile",
    title: "Mobile",
    skills: [
      "React Native",
      "Expo (EAS Build/Submit/Update)",
      "Push Notifications (FCM/APNs)",
      "Secure Storage",
      "Offline-First Patterns",
    ],
  },
  {
    id: "security",
    title: "Security & Auth",
    skills: [
      "JWT (RS256 Dual-Keypair)",
      "Revocable Sessions",
      "OTP / 2FA",
      "RBAC",
      "Rate Limiting",
      "Fraud Prevention",
      "OWASP Auditing (IDOR, SSRF, XSS)",
    ],
  },
  {
    id: "payments",
    title: "Payments & Cloud",
    skills: [
      "Paystack / Stripe / Flutterwave",
      "Market-Data APIs (Finnhub, Alpha Vantage)",
      "AWS (incl. Bedrock)",
      "Cloudflare R2 / S3",
      "Docker",
      "GitLab CI/CD",
    ],
  },
];

export default categories;
